define('modules/editor/views/elements/social',['require','exports','module','./element','ldsh!../../templates/elements/social'],function(require, exports, module) {
  "use strict";
  var Element = require("./element");

  module.exports = Element.extend({
    template: require("ldsh!../../templates/elements/social"),
    className: "ed-panel-item ed-item-socialbox"
  });
});

